import { render } from "./Events.vue?vue&type=template&id=f7aeec2c&ts=true"
import script from "./Events.vue?vue&type=script&lang=ts"
export * from "./Events.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__